import React from 'react';
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker
} from 'react-google-maps';
import { Card } from 'semantic-ui-react';

const WeatherMap = withScriptjs(
	withGoogleMap(({ lat, lng, isMarkerShown }) => (
		<Card.Content>
			<GoogleMap defaultZoom={12} defaultCenter={{ lat, lng }}>
				{isMarkerShown && <Marker position={{ lat, lng }} />}
			</GoogleMap>
		</Card.Content>
	))
);

export default WeatherMap;



// WEBPACK FOOTER //
// ./src/components/WeatherMap.js